import { render, staticRenderFns } from "./ProblemasDelHabla.vue?vue&type=template&id=075eb83b"
import script from "./ProblemasDelHabla.vue?vue&type=script&lang=js"
export * from "./ProblemasDelHabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports